import { createAction, props } from '@ngrx/store';
import { ResponseClientAdmission, RequestClientAdmission } from '../../shared/interfaces';
import { ClientAdmissionTypes } from '../../shared/enums';


export const getClientAdmission = createAction(
    ClientAdmissionTypes.CAE,
    props<{ request: RequestClientAdmission}>()
);

export const getClientAdmissionSucess = createAction(
    ClientAdmissionTypes.CAE_SUCCESS,
    props<{ response: ResponseClientAdmission }>()
);

export const getClientAdmissionError = createAction(
    ClientAdmissionTypes.CAE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ClientAdmissionTypes.CLEAN_STATE
);
